<template>
  <v-layout row justify-end style="flex-wrap: nowrap;">
    <v-btn
      @click.stop="$emit('approve')"
      x-small
      icon
      text
      :color="approveColor"
      class="ma-0  mr-2"
    >
      <v-icon>assignment_turned_in</v-icon>
    </v-btn>

    <v-btn
      v-if="!isTaskBlocked"
      @click.stop="$emit('reject')"
      x-small
      icon
      text
      :color="rejectColor"
      class="ma-0 "
    >
      <v-icon>content_paste_off</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: "TaskDecisionButtons",

  props: {
    taskContents: {
      type: Array
    },
    uuid: {
      type: String
    },
    isTaskBlocked:{
      type: Boolean,
      default: false
    }
  },

  computed: {
    approveColor() {
      let color = "grey";
      if (this.taskContents) {
        let content = this.taskContents.find(item => item.uuid === this.uuid);
        if (content && content.decision === "approve") {
          color = "success";
        }
      }
      return color;
    },

    rejectColor() {
      let color = "grey";
      if (this.taskContents) {
        let content = this.taskContents.find(item => item.uuid === this.uuid);
        if (content && content.decision === "reject") {
          color = "error";
        }
      }
      return color;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FieldManagement/FieldWork/Data/TaskDecisionButtons.vue